
<template>
  <!-- 检测列表类别编辑、详情 -->
  <div class="contaier">
    <a-modal
      class=""
      :title="number == 0 ? '编辑' : '详情'"
      :visible="editRelevanceVisib"
      @cancel="closeVisible"
      width="70%"
      @ok="closeVisible"
    >
      <template slot="footer" v-if="number == 1">
        <a-button key="back" @click="closeVisible"> 取消 </a-button>
      </template>
      <div class="title">
        <span>污染物类别</span>
      </div>
      <div class="containerTop">
        <a-form-model :model="analysis" ref="analysisRef">
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="行业大类"
                prop="masterCategory"
              >
                <span>{{ analysis.masterCategory }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="行业子类"
                prop="subCategory"
              >
                <span>{{ analysis.subCategory }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="污染物类别"
                prop="pollutantName"
              >
                <span>{{ analysis.pollutantName }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="title">
        <span>选择污染物</span>
      </div>
      <div class="containerTop">
        <a-button type="primary" v-if="number == 0" @click="addCategory" style="margin-right: 5px">添加污染物</a-button>
        <div class="containerBottom" id="content_main_center_scroll">
          <a-table
            :data-source="pollutantList"
            bordered
            :loading="loading"
            :pagination="false"
            :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
          >
            <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
              <template scope="text, record, index">
                <!-- {{ (currPage - 1) * 10 + index + 1 }} -->
                 {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
              </template>
            </a-table-column>
            <a-table-column key="factorName" title="污染物名称" ellipsis="true" data-index="factorName" />
            <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
            <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
            <a-table-column key="price" v-if="number == 1" title="单价(元)" ellipsis="true" data-index="price" />
            <a-table-column title="操作" width="220px" v-if="number == 0">
              <template scope="text,record">
                <a @click="editRelevance(record)">删除</a>
              </template>
            </a-table-column>
          </a-table>
          <div class="pageBottom">
                <a-pagination
            v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			@showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="onShowSizeChange"
                />
            </div> 
        </div>
      </div>
    </a-modal>
      <!-- @changeAddPollutanVisiblet="changeAddPollutanVisiblet" 
      :ids="ids"
      -->
    <AddPollutant
      ref="addPollutant"
      :addPollutanVisiblet="addPollutanVisiblet"
      :factorName="factorName"
      @getList="getPolltantList"
      @getData="getPollutionList"
    ></AddPollutant>
  </div>
</template>

<script>
import { getRelationPollutantByTypes, getQuoteBaseFactorFilterList, deletePollutant } from '@/api/surrounding'
import { baseFactor } from '@/api/Industry'
import AddPollutant from './addPollutant.vue'

export default {
  components: {
    AddPollutant,
  },
  props: ['editRelevanceVisib', 'number', 'analysis'],
  data() {
    return {
         pagination:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
      // editRelevanceVisib: false
      pollutantList: [],
      currPage: 1,
      //添加污染物列表
    //   addPollutantList: [],
      addPollutanVisiblet: false,
      // 污染物名称
      factorName: '',
      ids: {},
      scroll_y: 150,
    }
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() + 180
      }, 1000)
    })
  },
  watch: {
    editRelevanceVisib() {
      this.getPollutionList()
    },
    // this.getRelevance()
  },
  methods: {
    // 分页
       onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getPollutionList()
      },
    //删除污染物
    editRelevance(row) {
      var _this = this
      var idNum = {}
      Object.assign(idNum, {
        masterCategoryId: this.analysis.masterCategoryId,
        subCategoryId: this.analysis.subCategoryId,
        pollutantTypeId: this.analysis.pollutantTypeId,
        pollutantId: row.id,
      })
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          deletePollutant(idNum).then((res) => {
            if (res.code == 200) {
              _this.getPollutionList()
              _this.$message.success(res.msg)
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          _this.$message.warning('你点击了取消')
        },
      })
    },
    // changeAddPollutanVisiblet(data) {
    //   this.addPollutanVisiblet = data
    // },
    //获得关联污染物列表数据
    getRelevance() {},
    //关闭弹窗
    closeVisible() {
      this.editRelevanceVisib = false
      this.$emit('changeEditRelevanceVisib', this.editRelevanceVisib)
    },
    // 子组件查询
    getPolltantList(data) {
      this.factorName = data
      this.getList()
    },
    // getList() {
    //   baseFactor({
    //     factorName: this.factorName,
    //     parentId: 1001,
    //   }).then((res) => {
    //     if (res.code == 200) {
    //       this.addPollutantList = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   })
    // },
    //添加污染物
    addCategory() {
      var ids = {}
      Object.assign(ids, {
        masterCategoryId: this.analysis.masterCategoryId,
        subCategoryId: this.analysis.subCategoryId,
        pollutantTypeId: this.analysis.pollutantTypeId,
        categoryId: 1001,
      })
      this.ids = ids 
      this.$nextTick(() => {
        this.$refs.addPollutant.init(this.ids)
      })
    },
    //获得污染物列表
    getPollutionList() {
      if (this.analysis) {
        getRelationPollutantByTypes({
          pageIndex: this.pagination.current,
          pageSize: this.pagination.pageSize,
          masterCategoryId: this.analysis.masterCategoryId,
          subCategoryId: this.analysis.subCategoryId,
          pollutantTypeId: this.analysis.pollutantTypeId,
        }).then((res) => {
          this.pollutantList = res.data.list
            this.pagination.totalCount= res.data.totalCount
        })
      }
    },
  },
}
</script>

<style scoped>
.pageBottom {
    margin: 10px;
    display: flex;
    flex-direction: row-reverse;
}
.containerBottom {
    margin-top: 10px;
}
</style>